










import { defineComponent } from '@vue/composition-api';
import tooltipInfo from '@/components/common/tooltip-info/index.vue';

const name = 'ttam-icon-button';

export default defineComponent({
  name,
  components: {
    tooltipInfo,
  },
  props: {
    icon: { type: String, default: '' },
    label: { type: String, default: '' },
    tips: { type: String, default: '' },
  },

  setup(props, { emit }) {
    function onClick() {
      emit('click');
    }

    return {
      onClick,
    };
  },
});
